import { useMemo } from 'react';

/**
 * Hook to count active filters from Cloudscape PropertyFilter tokens
 *
 * Settings pages use Cloudscape's PropertyFilter component which stores filters
 * as a 'tokens' array. This hook provides a consistent way to count active filters
 * across all Settings pages.
 *
 * For main pages (Audits, Questions, Tasks) that use custom filters, use the
 * countActiveFilters utility from filterPersistence.ts instead.
 *
 * @param queryFilters - Filter object from useFilterPersistence containing tokens array
 * @returns Number of active filter tokens
 */
export function useActivePropertyFilterCount(
  queryFilters: { tokens?: any[] } | undefined,
): number {
  return useMemo(() => {
    if (!queryFilters || !queryFilters.tokens) return 0;
    return queryFilters.tokens.length;
  }, [queryFilters]);
}
